import { FC } from "react";
import ReportsCarousel from "@modules/for-you/components/ReportsCarousel";
import { useReports } from "@modules/for-you/hooks";
import ReportsZeroState from "@modules/for-you/components/ReportsZeroState";
import ReportsInterimState from "@modules/for-you/components/ReportsInterimState";
import { PERSONALIZED_ADVICE_REPORTS_MODE } from "@modules/for-you/types";
import { Typography } from "@earned/core";

const Reports: FC = () => {
  const { mode, thumbnails } = useReports();

  return (
    <div className="flex h-full flex-1 flex-col space-y-3">
      <div className="flex flex-row space-x-2">
        <Typography variant="body-xl" weight="medium" color="primary">
          Personalized Advice
        </Typography>
        <Typography variant="body-xl" color="primary">
          For You
        </Typography>
      </div>
      <div className="flex h-full flex-1 flex-col">
        {mode === PERSONALIZED_ADVICE_REPORTS_MODE.ZERO_STATE && (
          <ReportsZeroState />
        )}
        {mode === PERSONALIZED_ADVICE_REPORTS_MODE.INTERIM_STATE && (
          <ReportsInterimState />
        )}
        {mode === PERSONALIZED_ADVICE_REPORTS_MODE.CAROUSEL && (
          <ReportsCarousel thumbnails={thumbnails} />
        )}
      </div>
    </div>
  );
};

export default Reports;
